import React from 'react';

import { P } from '../P/P';
import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE4_2 = () => (
  <Section>

    <P gapAfter>
      Mögliche Interessengruppen z. B.:
    </P>
    <UL disc>
      <LI>Altkleider-Industrie</LI>
      <LI>Altkleider selbst verwerten</LI>
      <LI>Faire Shops</LI>
      <LI>Faire Siegel</LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE4_2.js